export enum Events {
    LeadSubmit = 'leadSubmit',
    VirtualPageView = 'virtualPageView',
    Checkout = 'checkout',
    Purchase = 'purchase',
    AddToCart = 'addToCart',
    RemoveFromCart = 'removeFromCart',
    CustomPageView = 'customPageView',
}
